import "../../styles/dashboard.css";
import { useLocation, useNavigate } from "react-router-dom";
import { capitalizeWords } from "./capitalizeWords";
import formatDate from "./dateUtils";
import * as XLSX from "xlsx";

const PassportDetails = () => {
  const location = useLocation();
  const passportData = location.state?.passportData;
  const navigate = useNavigate();

  const getPassportNumber = (documents) => {
    const passportDocument = documents.find((doc) => doc.name === "Passport");
    return passportDocument ? passportDocument.number : "";
  };

  const getExpiryDate = (documents) => {
    const passportDocument = documents.find((doc) => doc.name === "Passport");
    return passportDocument ? passportDocument.expiryDate : "";
  };

  const getDaysLeft = (documents) => {
    const passportDocument = documents.find((doc) => doc.name === "Passport");
    if (passportDocument && passportDocument.expiryDate) {
      const expiryDate = new Date(passportDocument.expiryDate);
      const today = new Date();
      const timeDifference = expiryDate - today;
      const daysLeft = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      return daysLeft >= 0 ? daysLeft : 0;
    }
    return "";
  };

  const handleUpdatepassportDetails = (id) => {
    const employeeDataToUpdate = passportData.find(
      (employee) => employee.employee_information_id === id
    );
    if (employeeDataToUpdate) {
      navigate(`/passportupdate/${id}`, {
        state: { passportDataToUpdate: employeeDataToUpdate },
      });
    }
  };

  const downloadDataAsExcel = () => {
    const filename = "PassportDataExpiry.xlsx";
    const data = passportData.map((employee, index) => ({
      "SL No.": index + 1,
      "Employee ID": employee.employee_id,
      "Employee Details": capitalizeWords(employee?.employee_full_name),
      "Company Name": capitalizeWords(
        employee?.roles[0]?.company[0]?.company_name
      ),
      "Passport Number": getPassportNumber(employee.documents),
      "Expiry Date": getExpiryDate(employee.documents),
      "Days Left": getDaysLeft(employee.documents),
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Passport Data");
    XLSX.writeFile(workbook, filename);
  };


  return (
    <div className="board__layout">
      <div className="section-header">
        <h1>Passport Expiry Details</h1>
        <button className="expiry_download-btn" onClick={downloadDataAsExcel}>
          Download
        </button>
      </div>
      <div>
        <table>
          <thead>
            <tr>
              <th>SL No.</th>
              <th>Employee ID</th>
              <th>Employee Details</th>
              <th>Company Name</th>
              <th>Passport Number</th>
              <th>Expiry Date</th>
              <th>Days Left</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {passportData.map((employee, index) => {
              const id = employee.employee_information_id;

              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{employee.employee_id}</td>
                  <td>
                    <div className="leave_empName">
                      {capitalizeWords(employee?.employee_full_name)}
                    </div>
                    <div className="leave_designation">
                      {capitalizeWords(employee?.roles[0]?.role_name)}
                    </div>
                  </td>

                  <td>
                    {capitalizeWords(
                      employee?.roles[0]?.company[0]?.company_name
                    )}
                  </td>
                  <td>{getPassportNumber(employee.documents)}</td>
                  <td>{formatDate(getExpiryDate(employee.documents))}</td>
                  <td>{getDaysLeft(employee.documents)}</td>
                  <td>
                    <div className="visa_expiry-edit">
                      <button
                        onClick={() =>
                          handleUpdatepassportDetails(
                            employee.employee_information_id
                          )
                        }
                      >
                        Update
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PassportDetails;
